import React from 'react';
import { NavLink } from 'react-router-dom';
import { PanelLeftOpen, Search } from 'lucide-react';
import OfficeRailHint from './OfficeRailHint';
import { TooltipProvider } from '../ui/tooltip';
import './OfficeChatRail.css';

/** Receives the same permission-filtered catalogue as the full navigation. */
export default function OfficeChatRail({ modules = [], badges = {}, expanded, onMenu, onSearch, inert, userRole }) {
  return <TooltipProvider delayDuration={150} skipDelayDuration={100}><aside className="office-chat-rail" aria-label="Navegação compacta" inert={inert}>
    <OfficeRailHint label="Expandir menu"><button type="button" data-testid="chat-rail-menu" aria-label="Expandir menu" aria-expanded={expanded} aria-controls="office-main-sidebar" onClick={onMenu}><PanelLeftOpen size={20} aria-hidden="true" /></button></OfficeRailHint>
    <OfficeRailHint label="Buscar página"><button type="button" aria-label="Buscar página" onClick={onSearch}><Search size={19} /></button></OfficeRailHint>
    <nav aria-label="Páginas do Office">
      {modules.filter(group => group.items?.length).map(group => <div key={group.id} role="group" aria-label={group.label}>
        {group.items.filter(item => !(userRole === 'attendant' && item.path === '/gestor-xui/my-portfolio')).map(item => {
          const Icon = item.icon;
          const count = item.badgeKey ? badges[item.badgeKey] : 0;
          return <OfficeRailHint key={item.path} label={item.label}><NavLink to={item.path} end={item.path === '/dashboard' || item.path === '/team'} aria-label={count > 0 ? `${item.label}, ${count} aguardando resposta` : item.label}>
            <Icon size={20} strokeWidth={1.7} aria-hidden="true" />
            {count > 0 && <span className="office-chat-rail__badge" aria-hidden="true">{count > 99 ? '99+' : count}</span>}
          </NavLink></OfficeRailHint>;
        })}
      </div>)}
    </nav>
  </aside></TooltipProvider>;
}
